import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";

/**
 * Landed here after OAuth redirect. Clear cached data so dashboard shows the signed-in user's data, then go to dashboard.
 */
export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    queryClient.clear();
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-primary-200 border-t-primary-600 dark:border-primary-800 dark:border-t-primary-500" />
        <p className="text-sm text-slate-400 dark:text-slate-500">Sign-in successful. Redirecting…</p>
      </div>
    </div>
  );
}
